import { render, staticRenderFns } from "./InstaembedCompo.vue?vue&type=template&id=df599308&"
import script from "./InstaembedCompo.vue?vue&type=script&lang=js&"
export * from "./InstaembedCompo.vue?vue&type=script&lang=js&"
import style0 from "./InstaembedCompo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports